<div class="order-list-page">
  <div class="page-header">
    <h1>{{ 'SIGN_ORDER.HISTORY.TITLE' | translate }}</h1>
    <button nz-button nzType="primary" nzSize="large" *ngIf="canCreate" (click)="onNewOrderClick()">
      <i nz-icon nzType="plus"></i>
      {{ 'SIGN_ORDER.HISTORY.NEW_ORDER' | translate }}
    </button>
  </div>

  <nz-alert *ngIf="errorMessage" nzType="error" [nzMessage]="errorMessage" nzShowIcon></nz-alert>

  <section class="drafts-section" aria-labelledby="sign-order-drafts-heading">
    <div class="drafts-section__header">
      <h2 id="sign-order-drafts-heading">{{ 'SIGN_ORDER.DRAFTS.TITLE' | translate }}</h2>
    </div>

    <nz-alert *ngIf="draftErrorMessage" nzType="warning" [nzMessage]="draftErrorMessage" nzShowIcon></nz-alert>

    <nz-spin [nzSpinning]="isDraftLoading">
      <div *ngIf="drafts.length; else emptyDrafts" class="draft-list">
        <article *ngFor="let draft of drafts" class="draft-card">
          <div class="draft-card__summary">
            <div class="draft-card__meta">
              <span>{{ 'SIGN_ORDER.DRAFTS.LAST_UPDATED' | translate }}: {{ formatSignOrderDate(draft.updatedAt, translate.currentLang) }}</span>
              <span>{{ 'SIGN_ORDER.DRAFTS.PROPERTY_COUNT' | translate:{ count: draft.itemCount } }}</span>
              <span>{{ 'SIGN_ORDER.DRAFTS.TOTAL_SIGNS' | translate:{ count: draft.totalQuantity } }}</span>
            </div>
            <div class="draft-card__drilling">{{ getDrillingLabel(draft.drillingOption) }}</div>
          </div>
          <div class="draft-card__actions">
            <button nz-button nzType="default" (click)="onResumeDraft(draft.publicId)">
              {{ 'SIGN_ORDER.DRAFTS.RESUME' | translate }}
            </button>
            <button nz-button nzType="text" nzDanger (click)="confirmDeleteDraft(draft)">
              {{ 'SIGN_ORDER.DRAFTS.DELETE' | translate }}
            </button>
          </div>
        </article>
      </div>

      <ng-template #emptyDrafts>
        <p class="drafts-empty" *ngIf="!isDraftLoading && !draftErrorMessage">{{ 'SIGN_ORDER.DRAFTS.EMPTY' | translate }}</p>
      </ng-template>

      <nz-pagination
        *ngIf="draftTotal > draftPageSize"
        [(nzPageIndex)]="draftPage"
        [nzPageSize]="draftPageSize"
        [nzTotal]="draftTotal"
        (nzPageIndexChange)="loadDrafts($event)"
        nzSize="small"
        class="pagination"
      ></nz-pagination>
    </nz-spin>
  </section>

  <nz-spin [nzSpinning]="isLoading">
    <nz-table
      #basicTable
      [nzData]="orders"
      [nzShowPagination]="false"
      nzSize="middle"
      nzBordered="false"
      class="orders-table"
      *ngIf="orders.length; else emptyState"
    >
      <thead>
        <tr>
          <th>{{ 'SIGN_ORDER.HISTORY.ORDER_NUMBER' | translate }}</th>
          <th>{{ 'SIGN_ORDER.HISTORY.DATE' | translate }}</th>
          <th>{{ 'SIGN_ORDER.HISTORY.PRODUCT' | translate }}</th>
          <th>{{ 'SIGN_ORDER.HISTORY.PROPERTIES' | translate }}</th>
          <th>{{ 'SIGN_ORDER.HISTORY.TOTAL_COPIES' | translate }}</th>
          <th>{{ 'SIGN_ORDER.HISTORY.GROSS_TOTAL' | translate }}</th>
          <th>{{ 'SIGN_ORDER.HISTORY.STATUS' | translate }}</th>
          <th>{{ 'SIGN_ORDER.HISTORY.ACTIONS' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let order of orders" class="order-row" (click)="selectOrder.emit(order.publicId)">
          <td><code class="order-number">{{ order.orderNumber }}</code></td>
          <td class="text-muted">{{ formatSignOrderDate(order.createdAt, translate.currentLang) }}</td>
          <td>{{ localizedText(order.product?.name) }}</td>
          <td>{{ order.uniquePropertyCount }}</td>
          <td>{{ order.totalCopies }}</td>
          <td class="text-bold">{{ formatCents(order.grossTotalCents, order.currency) }}</td>
          <td>
            <nz-tag [nzColor]="getStatusColor(order.status)">{{ getStatusLabel(order.status) }}</nz-tag>
          </td>
          <td>
            <span class="view-link">{{ 'SIGN_ORDER.HISTORY.VIEW_DETAIL' | translate }} <i nz-icon nzType="right"></i></span>
          </td>
        </tr>
      </tbody>
    </nz-table>

    <ng-template #emptyState>
      <div class="empty-state">
        <div class="empty-icon-wrap">
          <i nz-icon nzType="inbox" class="empty-icon"></i>
        </div>
        <h3>{{ 'SIGN_ORDER.HISTORY.NO_ORDERS' | translate }}</h3>
        <p class="empty-hint" *ngIf="canCreate">{{ 'SIGN_ORDER.HISTORY.PLACE_FIRST_ORDER' | translate }}</p>
        <button nz-button nzType="primary" nzSize="large" *ngIf="canCreate" (click)="onNewOrderClick()">
          <i nz-icon nzType="plus"></i>
          {{ 'SIGN_ORDER.HISTORY.PLACE_FIRST_ORDER' | translate }}
        </button>
      </div>
    </ng-template>

    <nz-pagination
      *ngIf="total > pageSize"
      [(nzPageIndex)]="page"
      [nzPageSize]="pageSize"
      [nzTotal]="total"
      (nzPageIndexChange)="loadOrders($event)"
      nzSize="small"
      class="pagination"
    ></nz-pagination>
  </nz-spin>
</div>
